import React, { useEffect, useState } from "react";
import "./GestionAdhesions.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { HiSearch } from "react-icons/hi";
import { InputText } from "primereact/inputtext";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { Dropdown } from "primereact/dropdown";
import { fr } from "date-fns/locale";
import { useRef } from "react";
import GestionRecruteurCard from "./GestionRecruteurCard/GestionRecruteurCard";
import { updatePagination } from "Redux/Actions/paginationActions";
import { CgClose } from "react-icons/cg";
import { useFetchGetPagination } from "Services/api";
import { Toast } from "primereact/toast";
import { updateRequests } from "Redux/Actions/requestsActions";
import GestionAlumniCard from "./GestionAlumniCard/GestionAlumniCard";
import TempPagination from "Components/Pagination/TempPagination";

registerLocale("fr", fr);

/**
 * Permet d'afficher la page de requêtes et exports
 * Page accessible uniquement pour les administrateurs
 */
// TO DO : une fois les specs finalisées, intégrer la page
const GestionAdhesions = (props) => {
  // Label des status
  const listStatus = [
    {
      label: "Validé",
      code: "Validé",
    },
    {
      label: "Refusé",
      code: "Refusé",
    },
    {
      label: "En attente",
      code: "En attente",
    },
  ];
  const [filterStatus, setFilterStatus] = useState(listStatus[2]);

  const [recruiterRequestsUrl, setRecruiterRequestsUrl] = useState(null);

  const recruiterRequestsQuery = useFetchGetPagination(
    recruiterRequestsUrl,
    props.auth.token,
    props.handleUpdateRequests
  );

  const [alumniRequestsUrl, setAlumniRequestsUrl] = useState(null);
  const alumniRequestsQuery = useFetchGetPagination(
    alumniRequestsUrl,
    props.auth.token,
    props.handleUpdateRequests
  );

  const memberRef = useRef(null);
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);

  // State qui permet de gérer les boutons en fonction des clics
  const [btnsStatus, setBtnsStatus] = useState([
    {
      isActive: true,
      text: "Valider les demandes d'adhésion recruteur",
      user: "recruteur",
    },
    {
      isActive: false,
      text: "Valider les demandes d'adhésion alumni",
      user: "alumni",
    },
    {
      isActive: false,
      text: "Valider les comptes temporaires étudiants",
      user: "etudiant",
    },
  ]);
  const [typeOfUser, setTypeOfUser] = useState("recruteur");

  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [filtreDate, setFiltreDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setFiltreDate(dates);
  };

  // Hook demise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
  useEffect(() => {
    return () => {
      props.handleUpdatePagination({ currentPage: 1 });
      props.handleUpdatePagination({ paginationBasicFirst: 0 });
      props.handleUpdatePagination({ paginationBasicRows: 12 });
    };
  }, []);

  //Fonction qui permet de filtrer en fonction de la date
  const filterByDate = (filtreDate, url) => {
    if (filtreDate[0] !== null)
      url.searchParams.set(
        "createdAt[after]",
        new Date(filtreDate[0]).toISOString()
      );
    if (filtreDate[1] !== null)
      url.searchParams.set(
        "createdAt[before]",
        new Date(filtreDate[1]).toISOString()
      );
  };

  const handleFilter = () => {
    setTypeOfUser(
      btnsStatus[0].isActive
        ? "recruteur"
        : btnsStatus[1].isActive
        ? "alumni"
        : null
    );
    let url = new URL(
      `${process.env.REACT_APP_BASE_URL_API}${
        btnsStatus[0].isActive
          ? "/recruiter_membership_requests"
          : btnsStatus[1].isActive
          ? "/alumni_membership_requests"
          : null
      }`
    );

    //? Limite les données à 12 par page
    url.searchParams.set("itemsPerPage", 12);

    if (filterStatus.label) url.searchParams.set("status", filterStatus.label);
    if (filtreMotsCles) url.searchParams.set("keyword", filtreMotsCles);
    if (filtreDate) filterByDate(filtreDate, url);

    if (btnsStatus[0].isActive) setRecruiterRequestsUrl(url);
    else if (btnsStatus[1].isActive) setAlumniRequestsUrl(url);
  };

  useEffect(() => {
    // Si un filtre est actif lance le filtrage
    if (filtreMotsCles || filterStatus || filtreDate) {
      //? Debounce pour éviter de lancer la requête à chaque changement de lettre (handleFilter())
      const timeoutId = setTimeout(() => {
        handleFilter();
      }, 500);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [btnsStatus, filtreMotsCles, filterStatus, filtreDate]);

  return (
    <div className="gestion_adhesion_admin">
      {props.auth.isConnected && (
        <div className="article_actu">
          <Toast ref={uploadToast} />
          <Toast ref={cancelToast} />
          <div className="titre_de_page">
            <h1 className="h1_trait_dessus">
              {props.items[props.activeIndex].label}
            </h1>
            <div className="title_filtres">
              {/* Filtre par mots clés */}
              <div className="title_filtres__keyword">
                <HiSearch className="searchBar_groupe_finder_icon" />
                <InputText
                  placeholder={"Rechercher une demande"}
                  value={filtreMotsCles}
                  onChange={(e) => {
                    setFiltreMotsCles(e.target.value);
                  }}
                  className="membership_input_text"
                />
              </div>
              {/* Filtre par statut */}
              <Dropdown
                value={filterStatus}
                optionLabel="label"
                className="membership_input_search"
                placeholder="Filtrer par statut"
                options={listStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                }}
              />
              {/* Filtre par date */}
              <div className="title_filtres__dates">
                <ReactDatePicker
                  placeholderText="Filtrer par date"
                  selected={startDate}
                  onChange={(e) => {
                    onChangeDate(e);
                  }}
                  dateFormat="dd/MM/yyyy"
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                />
                {filtreDate !== null && (
                  <CgClose
                    onClick={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setFiltreDate(null);
                    }}
                  ></CgClose>
                )}
              </div>
            </div>
          </div>
          <div className="member__container" ref={memberRef}>
            <div className="member__container__left">
              {btnsStatus.map((btnStatus, index) => {
                return (
                  <button
                    className={
                      btnStatus.isActive
                        ? "btn-bleu " + "item" + index
                        : "btn-blanc " + "item" + index
                    }
                    onClick={() => {
                      var i = 0;
                      setBtnsStatus(
                        btnsStatus.map((btn) => {
                          btn.isActive = i == index;
                          i++;
                          return btn;
                        })
                      );
                    }}
                    key={index}
                  >
                    {btnsStatus[index].text}
                  </button>
                );
              })}
            </div>
            <div className="member__container__right">
              {typeOfUser === "recruteur" &&
                recruiterRequestsQuery?.data?.map((request, index) => (
                  <GestionRecruteurCard
                    key={index}
                    values={request}
                    uploadToast={uploadToast}
                    cancelToast={cancelToast}
                    handleFilter={handleFilter}
                  ></GestionRecruteurCard>
                ))}
              {typeOfUser === "alumni" &&
                alumniRequestsQuery?.data?.map((request, index) => (
                  <GestionAlumniCard
                    key={index}
                    values={request}
                    uploadToast={uploadToast}
                    cancelToast={cancelToast}
                    handleFilter={handleFilter}
                  ></GestionAlumniCard>
                ))}
            </div>
          </div>
        </div>
      )}
      <TempPagination
        result={
          btnsStatus[0].isActive
            ? recruiterRequestsQuery
            : btnsStatus[1].isActive
            ? alumniRequestsQuery
            : null
        }
        rows={12}
        refItemParent={memberRef}
      />
    </div>
  );
};

GestionAdhesions.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  handleUpdateRequests: PropTypes.func,
  requests: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  pagination: state.pagination,
  requests: state.requests,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
  handleUpdateRequests: (value) => {
    dispatch(updateRequests(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GestionAdhesions);
